import TransactionCategory from './TransactionCategory';

export default TransactionCategory;
